<!-- <template> -->
  <template>
    <!-- <div className="wrapper"> -->
    <v-menu offset-y max-height="500px" min-width="300px" max-width="450px" v-model="menu">
      <template v-slot:activator="{ on }">
        <v-btn ref="activator" color="primary" v-on="on" icon>
          <v-badge color="green" :content="count" overlap v-if="count !== 0">
            <v-icon>mdi-bell-outline</v-icon>
          </v-badge>
          <v-icon v-else>mdi-bell-outline</v-icon>
        </v-btn>
      </template>
  
      <template v-for="(item, index) in items">
        <v-card flat :key="index" link @click="open(item)">
          <v-card-text>
            <div class="caption">{{ format(item) }}</div>
            <div class="body-1 black--text">
              {{ item.title }}
            </div>
            <div class="body-2">
              {{ item.body }}
            </div>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </template>
      <v-card flat>
    <v-card-text class="text-right">
      <v-btn text color="red" @click="updateSeen()">Clear All</v-btn>
    </v-card-text>
  </v-card>
    </v-menu>
    <!-- <div class="alertWrapper">
        <template v-for="(item, index) in alerts">
          <v-card flat :key="index" link>
            <v-card-text>
              <div class="caption">{{ format(item) }}</div>
              <div class="body-1 black--text">
                {{ item.title }}
              </div>
              <div class="body-2">
                {{ item.body }}
              </div>
              <v-btn text color="green" @click="updateSeenSingle(item)"> Okay </v-btn>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </template>
      </div> -->
    <!-- </div> -->
  </template>
  
  <script>
  import { fs, notifications, chat_list } from "../assets/js/firebase";
  import { formatDate, getDate } from "./../assets/js/common";
  export default {
    data() {
      return {
        menu: false,
        activatorClickEvent: null, // Store only the `click` event
      };
    },
    watch: {
      // menu(val) {
      //   if (val) {
      //     this.updateSeen();
      //   }
      // },
      items: {
        handler(newItems, oldItems) {
        const vm = this;
        if (newItems.length > oldItems.length) {
          const recentUnseenNotifications = newItems?.find(notification => !notification.seen)
          if (recentUnseenNotifications && Object.keys(recentUnseenNotifications).length>0) {
            const alertKey = `notification_alert_${recentUnseenNotifications.id}`;
            // ✅ Check if alert was already shown in another tab
            if (localStorage.getItem(alertKey)) return;
  
            // ✅ Mark it as shown in localStorage so other tabs skip it
            localStorage.setItem(alertKey, "shown");
            vm.$alert.show(
              recentUnseenNotifications?.body,
              recentUnseenNotifications?.title,
              () => {
                vm.updateSeenSingle(recentUnseenNotifications);
                // Passing the on and attrs to the callback
                const { on, attrs } = vm.$refs.activator;
                vm.$emit("click", on, attrs);  // Trigger the event
              },
              "View all Notifications", 
              ()=>{
                this.menu =true;
              }
            );
          }
        }
      },
        deep: true
    }
    },
    computed: {
      items() {
        return this.$store.getters.notifications.filter(notification => !notification.seen);
      },
      count() {
        let count = 0;
        this.items.forEach(({ seen }) => {
          if (!seen) count++;
        });
        return count;
      },
      alerts() {
        return this.$store.getters.notifications.filter(ele => ele.seen === false)?.[0] || null;
      },
    },
    methods: {
      open({ ref, type }) {
        if (type === "sms_reply") {
          var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          if (isMobile) {
            this.openChat(ref);
          } else {
            this.$router.push({
              path: "/sms",
              query: { phone: ref, ts: new Date().getTime() }
            });
          }
        } else {
          const targetRoute = `/jobs/${ref}`;
          if (this.$route.path !== targetRoute) {
            this.$router.push(targetRoute);
          }
        }
      },
      updateSeen() {
        let batch = fs.batch();
        let list = [];
        this.items.forEach(item => {
          let updated_at = getDate();
          let ref = notifications.doc(item.id);
          if (!item.seen) batch.update(ref, { seen: true, updated_at });
          list.push(item);
        });
        let changes = [];
        for (let item of list) {
          item.seen = true;
          changes.push(item);
        }
        this.$store.commit("SET_NOTIFICATIONS", changes);
        batch.commit();
      },
      updateSeenSingle(item) {
        let updated_at = getDate();
        let ref = notifications.doc(item.id);
  
        // Update the seen status and timestamp for the single notification
        if (!item.seen) {
          ref.update({ seen: true, updated_at });
        }
  
        // Update the local store with the changes
        item.seen = true;
        this.$store.commit("SET_NOTIFICATIONS", [item]);
      },
      async openChat(phone) {
        const vm = this;
        if (phone) {
          try {
            vm.$root.loader = true;
            let snap = await chat_list.doc(phone).get();
            if (snap.exists) {
              let { phone, name } = snap.data();
              vm.$router.push({
                path: `/sms/${phone}`,
                query: { phone, name, ts: new Date().getTime() }
              });
            }
            vm.$root.loader = false;
          } catch (error) {
            vm.$root.loader = false;
            vm.$root.alert(error.message);
          }
        }
      },
      format({ updated_at }) {
        return formatDate(updated_at);
      }
    }
  };
  </script>
  
  <style>
  .wrapper {
    position: relative;
  }
  
  .alertWrapper {
    position: absolute;
    right: 30px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  </style>
  